var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _c(
            "app-link",
            { attrs: { to: _vm.resolvePath(_vm.item.path) } },
            [
              _c(
                "el-menu-item",
                {
                  class: { "submenu-title-noDropdown": !_vm.isNest },
                  attrs: { index: _vm.resolvePath(_vm.item.path) },
                },
                [
                  _vm.item.meta
                    ? _c("item", {
                        attrs: {
                          icon: _vm.item.meta.icon || _vm.item.meta.icon,
                          title: _vm.generateTitle(_vm.item.meta.title),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }